import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider, WebProvider } from './_contexts';

ReactDOM.render(
  <React.StrictMode>
    <WebProvider>
      <ThemeContextProvider>
        <App />
      </ThemeContextProvider>
    </WebProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
